import { useState } from 'react';

// Components
import MenuItem from '../MenuItem';
import LoadingMenu from '../LoadingMenu';

// Styles
import styles from './index.module.sass';

export default function Menu({
  webservice,
  setCatselected,
  catSelected,
  getCookie,
  history,
  match,
  menuCategories,
  loading,
  screenSize,
}) {
  const [open, setOpen] = useState('');

  return (
    <div className={styles.menu}>
      {(loading && <LoadingMenu />) ||
        menuCategories.map((val, key) => {
          return (
            <MenuItem
              key={key}
              itemId={key}
              node={val}
              setCatselected={setCatselected}
              catSelected={catSelected}
              open={open}
              setOpen={setOpen}
              history={history}
              match={match}
              screenSize={screenSize}
            />
          );
        })}
    </div>
  );
}
